<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Setting</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a routerLink="/home" (click)="SetInactive()">Home</a></li>
            <li class="breadcrumb-item active">Setting</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <!-- Main content -->
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card card-primary card-outline">
            <div class="card-header">
              <h3 class="card-title">
                <i class="fas fa-cog"></i>
                Setting
              </h3>
            </div>
            <!-- /.card-header -->
            <form [formGroup]="settingForm" (ngSubmit)="update()">
              <div class="card-body row">
                <div class="col-12 form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="userRegister" name="userRegister" formControlName="userRegister">
                        <label class="custom-control-label" for="userRegister">
                            Show registration page.
                        </label>
                    </div>
                </div>
                <div class="col-12 form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="emailVerificationDisable" name="emailVerificationDisable" formControlName="emailVerificationDisable">
                        <label class="custom-control-label" for="emailVerificationDisable">
                            User can register without email verification.
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 form-group">
                    <label for="userRole">
                        User registration will be under role:
                    </label>
                </div>
                <div class="col-lg-2 form-group">
                    <select [ngClass]="{ 'is-invalid': settingForm.get('userRole').errors && settingForm.get('userRole').touched }" class="form-control" id="Role" name="Role" formControlName="userRole">
                        <option value="">Select Please ...</option>
                        <option *ngFor="let rl of roles" [value]="rl.id">{{rl.name}}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="settingForm.get('userRole').hasError('required') && settingForm.get('userRole').touched">You can't leave this empty.</div>
                </div>
                <div class="col-12 form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="recoverPassword" name="recoverPassword" formControlName="recoverPassword">
                        <label class="custom-control-label" for="recoverPassword">
                            User can recover password.
                        </label>
                    </div>
                </div>
                <div class="col-12 form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="changePassword" name="changePassword" formControlName="changePassword">
                        <label class="custom-control-label" for="changePassword">
                            User can change password.
                        </label>
                    </div>
                </div>
                <div class="col-12 form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="changeProfile" name="changeProfile" formControlName="changeProfile">
                        <label class="custom-control-label" for="changeProfile">
                            User can change profile information.
                        </label>
                    </div>
                </div>
              </div>
              <div class="col-12 form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="twoFactorEnabled" name="twoFactorEnabled" formControlName="twoFactorEnabled">
                    <label class="custom-control-label" for="twoFactorEnabled">
                        User can enable 2-step verification.
                    </label>
                </div>
              </div>
              <div class="col-12 form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="externalLogin" name="externalLogin" formControlName="externalLogin">
                    <label class="custom-control-label" for="externalLogin">
                        User can login by external authentication.
                    </label>
                </div>
              </div>
              <div class="card-footer">
                  <button type="submit" class="btn btn-primary float-right" [disabled]="!settingForm.valid">
                    <i class="fas fa-save"></i>
                    Save
                  </button>
              </div>
            </form>
            <!-- /.tab-content -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
  </section>
  <!-- /.content -->
</div>